/**
 * @generated SignedSource<<71b5433956ab909022f022160c206172>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingId",
        "variableName": "bookingId"
      }
    ],
    "concreteType": "InvoiceResponseType",
    "kind": "LinkedField",
    "name": "getInvoiceUrlByBookingId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DownloadInvoiceUrlQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DownloadInvoiceUrlQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28234871a0a768eec6c85eb701bf7594",
    "id": null,
    "metadata": {},
    "name": "DownloadInvoiceUrlQuery",
    "operationKind": "query",
    "text": "query DownloadInvoiceUrlQuery(\n  $bookingId: String!\n) {\n  getInvoiceUrlByBookingId(bookingId: $bookingId) {\n    url\n  }\n}\n"
  }
};
})();

node.hash = "5071828bfa8fefb18bf3ef3d9536a6e3";

module.exports = node;
